export const activateIub = iub => {
  if (iub && iub.cs) {
    const consetPreferences = iub.cs.api?.getPreferences()?.uspr ?? {};
    // Check if consetPreferences is empty or contains at least one truthy value
    const isConsetPreferencesValid = () => {
      // Check if consetPreferences is empty
      const isEmpty = Object.keys(consetPreferences).length === 0;

      // Check if any value in consetPreferences is truthy
      const hasTruthyValue = Object.values(consetPreferences).some(value => value);

      // Return true if consetPreferences is empty or has at least one truthy value
      return isEmpty || hasTruthyValue;
    };

    // If consetPreferences is valid, start activation
    if (isConsetPreferencesValid()) {
      iub.cs.startActivation?.();
    }
  }
};

/**
 * Check if user has consented to social media conversions
 * @returns {boolean}
 */
export const hasConsentedToSocialMediaConversion = () => {
  // eslint-disable-next-line no-underscore-dangle
  if (!window._iub || !window._iub.cs || !window._iub.cs.api) {
    return true;
  }

  try {
    // eslint-disable-next-line no-underscore-dangle
    const preferences = window._iub.cs.api.getPreferences();
    if (!preferences || !preferences.uspr) {
      return true;
    }

    const { s: saleConsent, adv: advertisingConsent } = preferences.uspr;
    return saleConsent === true && advertisingConsent === true;
  } catch (error) {
    console.warn("Error checking Iubenda consent preferences:", error);
    return true;
  }
};

export default activateIub;
